<template>
	<section class="signature">
		<div class="signatureBox">
			<div class="canvasBox" ref="canvasHW">
				<div @click="this.clickCount + 1">
          <canvas ref="canvasF" id="canvas" @touchstart='touchStart' @touchmove='touchMove' @touchend='touchEnd'
                  @mousedown="mouseDown" @mousemove="mouseMove" @mouseup="mouseUp"></canvas>
        </div>
				<div class="btnBox">
					<el-button type="warning" @click="overwrite" v-show="false">重置</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="overwrite"></el-button>
					<el-button type="primary" icon="el-icon-check" @click="commit()"></el-button>
				</div>
			</div>
		</div>
		<img class="imgCanvas" :src="imgUrl" v-show="false">
	</section>
</template>

<script>
	export default {
		name: 'dzqm',
		props: {
			dialogVisible: Boolean
		},
		data() {
			return {
				stageInfo: '',
				imgUrl: '',
        clickCount: 0,
        openSign: '',
				client: {},
				points: [],
				canvasTxt: null,
				startX: 0,
				startY: 0,
				moveY: 0,
				moveX: 0,
				endY: 0,
				endX: 0,
				w: null,
				h: null,
				isDown: false,
				isViewAutograph: this.$route.query.isViews > 0,
				contractSuccess: this.$route.query.contractSuccess
			}
		},
		mounted() {
		  this.openSign = this.$refs.canvasF.toDataURL()
			let canvas = this.$refs.canvasF
			canvas.height = this.$refs.canvasHW.offsetHeight - 50
			canvas.width = this.$refs.canvasHW.offsetWidth - 5
			this.canvasTxt = canvas.getContext('2d')
			this.stageInfo = canvas.getBoundingClientRect()
		},
		methods: {
      isCanvasBlank(canvas){
        let blank = document.createElement('canvas');//系统获取一个空canvas对象
        blank.width = canvas.width;
        blank.height = canvas.height;
        return canvas.toDataURL() == blank.toDataURL();//比较值相等则为空
      },
			//mobile
			touchStart(ev) {
				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clienX,
						y: ev.targetTouches[0].clientY,
					}
					this.startX = obj.x
					this.startY = obj.y
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
				}
			},
			touchMove(ev) {
				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clientX - this.stageInfo.left,
						y: ev.targetTouches[0].clientY - this.stageInfo.top
					}
					this.moveY = obj.y
					this.moveX = obj.x
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.startY = obj.y
					this.startX = obj.x
					this.points.push(obj)
				}
			},
			touchEnd(ev) {
				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clientX - this.stageInfo.left,
						y: ev.targetTouches[0].clientY - this.stageInfo.top
					}
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
				}
			},
			//pc
			mouseDown(ev) {
				ev = ev || event
				ev.preventDefault()
				if (1) {
					let obj = {
						x: ev.offsetX,
						y: ev.offsetY
					}
					this.startX = obj.x
					this.startY = obj.y
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
					this.isDown = true
				}
			},
			mouseMove(ev) {
				ev = ev || event
				ev.preventDefault()
				if (this.isDown) {
					let obj = {
						x: ev.offsetX,
						y: ev.offsetY
					}
					this.moveY = obj.y
					this.moveX = obj.x
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.startY = obj.y
					this.startX = obj.x
					this.points.push(obj)
				}
			},
			mouseUp(ev) {
				ev = ev || event
				ev.preventDefault()
				if (1) {
					let obj = {
						x: ev.offsetX,
						y: ev.offsetY
					}
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
					this.points.push({
						x: -1,
						y: -1
					})
					this.isDown = false
				}
			},
			//重写
			overwrite() {
				this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
				this.points = []
			},

			base64ImgtoFile(dataurl, filename = 'file') {
				let arr = dataurl.split(',')
				let mime = arr[0].match(/:(.*?);/)[1]
				let suffix = mime.split('/')[1]
				let bstr = atob(arr[1])
				let n = bstr.length
				let u8arr = new Uint8Array(n)
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n)
				}
				return new File([u8arr], `${filename}.${suffix}`, {
					type: mime
				})
			},
			//提交签名
			commit() {
				//var imgFile = this.base64ImgtoFile(this.$refs.canvasF.toDataURL());
        let c=document.getElementById("canvas"); // 获取html的canvas对象
        if(this.isCanvasBlank(c)){
          alert("请签名后再确认");
        }else{
          this.imgUrl = this.$refs.canvasF.toDataURL();
          this.$emit("commit", this.imgUrl)
          this.overwrite();
        }


			}
		}
	}
</script>


<style scoped>
	.signatureBox {
		width: 100%;
		height: calc(100% - 50px);
		box-sizing: border-box;
		overflow: hidden;
		background: #fff;
		z-index: 100;
		display: flex;
		flex-direction: column;
	}

	.canvasBox {
		box-sizing: border-box;
		flex: 1;
	}

	canvas {
		border: 1px solid #7d7d7d;
	}

	.btnBox {
		padding: 10px;
		display: flex;
		text-align: center;
	}

	.btnBox button:first-of-type {
		background: transparent;
		border-radius: 4px;
		height: 40px;
		width: 80px;
		font-size: 14px;
	}

	.btnBox button:last-of-type {
		background: #71b900;
		color: #fff;
		border-radius: 4px;
		height: 40px;
		width: 80px;
		font-size: 14px;
	}
</style>
